import createHistory from 'history/createBrowserHistory'
import URL from './URL.js'

// see https://www.npmjs.com/package/history
const history = createHistory()

export const addListener = (cb) => {
  var safeCB = (...args) => {
    try {
      cb(...args)
    } 
    catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[ ERROR ] exeption in url change listener', e)
    }
  }
  history.listen(safeCB)
}

// Register change listener on every page
addListener( (_location, _action) => {
    var url = new URL(window.location.href)
    if (jQuery) {
      var event = jQuery.Event("foundation:page:navigate");
      event.url = window.location.href;
      event.params = url.params();
      jQuery(document).trigger(event);
    }
})


export const removeListener = (handle) => {
  handle()
}

export const replaceUrl = (path, params) => {
  var urlString = `${path}?${URL.objectToQueryString(params)}`
  history.replace(urlString)
}

export const replaceUrlParams = (params) => {
  var url = new URL(window.location.href)
  var urlString = `${url.path()}?${URL.objectToQueryString(params)}`
  history.replace(urlString)
}

export const pushUrl = (path, params) => {
  var urlString = `${path}?${URL.objectToQueryString(params)}`
  history.push(urlString)
}

export const pushUrlParams = (params) => {
  var url = new URL(window.location.href)
  var urlString = `${url.path()}?${URL.objectToQueryString(params)}`

  if (urlString !== url.relativeToString()) {
    history.push(urlString)
  }
}

export const pushOneParam = (param, value) => {
  var url = new URL(window.location.href)
  var newParams = {
    ...url.params(),
    [param]: value
  }
  var urlString = `${url.path()}?${URL.objectToQueryString(newParams)}`
  history.push(urlString)
}

window.Foundation.History = {
  addListener,
  removeListener,
  replaceUrl,
  replaceUrlParams,
  pushUrl,
  pushUrlParams,
  pushOneParam
}
